import { useEffect, useState } from 'react'

import {
  FaEnvelope as EmailIcon,
  FaPhone as PhoneIcon,
  FaUserGraduate as AlunoIcon,
  FaUserTag as SituacaoIcon
} from 'react-icons/fa'
import { HiAcademicCap as CursoIcon } from 'react-icons/hi'

import { CarometroAluno } from '@core/types/services'
import { Modal } from '@presentation/components/organisms'
import { ModalProps } from '@presentation/types/components/organisms'
import { toTitleCase } from '@presentation/utils'

import { formatAlunoPhone } from '../../utils'
import * as S from './styles'

type Props = {
  aluno: CarometroAluno | null
  isOpen: boolean
  onClose: () => void
  photoSrc?: string | null
}

type DetailItemProps = {
  icon: React.ReactNode
  label: string
  value?: string | null
}

const DetailItem: React.FC<DetailItemProps> = ({ icon, label, value }) => {
  return (
    <S.DetailItem>
      <S.DetailLabel>
        {icon}
        {label}
      </S.DetailLabel>
      <S.DetailValue>{value ?? '-'}</S.DetailValue>
    </S.DetailItem>
  )
}

const AlunoDetailsModal: React.FC<Props> = ({
  aluno,
  isOpen,
  onClose,
  photoSrc
}) => {
  const [hasPhotoError, setHasPhotoError] = useState(false)

  useEffect(() => {
    setHasPhotoError(false)
  }, [photoSrc])

  if (!aluno) return null

  const title = toTitleCase(aluno.nome ?? aluno.nomeCompleto ?? 'Aluno')

  const modalConfigs: ModalProps = {
    isOpen,
    icon: <AlunoIcon />,
    title: 'Detalhes do Aluno',
    description: 'Confira abaixo os dados do aluno selecionado.',
    size: 'sm',
    onClose
  }

  return (
    <Modal {...modalConfigs}>
      <S.Content>
        <S.PhotoWrapper>
          {photoSrc && !hasPhotoError ? (
            <S.Photo
              src={photoSrc}
              alt={`Foto do aluno ${title}`}
              onError={() => setHasPhotoError(true)}
            />
          ) : (
            <S.PhotoFallback aria-hidden="true" />
          )}
        </S.PhotoWrapper>

        <S.Name>{title}</S.Name>

        <S.Badge>Matrícula: {aluno.matricula ?? '-'}</S.Badge>

        <S.DetailsList>
          <DetailItem
            icon={<CursoIcon />}
            label="Curso"
            value={aluno.curso ?? '-'}
          />
          <DetailItem
            icon={<SituacaoIcon />}
            label="Situação"
            value={aluno.situacao ?? '-'}
          />
          <DetailItem
            icon={<PhoneIcon />}
            label="Telefone"
            value={formatAlunoPhone(aluno.telefone)}
          />
          <DetailItem
            icon={<EmailIcon />}
            label="E-mail"
            value={aluno.email ?? '-'}
          />
        </S.DetailsList>
      </S.Content>
    </Modal>
  )
}

export default AlunoDetailsModal
